import { REQUEST_OWNERSHIPAREAS, RESPONSE_OWNERSHIPAREAS, REQUEST_OWNERSHIPAREAS_FAILURE } from "../actions/ownershipAreasActions";
import { states } from "./queriesStates";

const initialState = {
  dataState: states.NOT_REQUESTED,
  ownershipAreas: [],
  errors: null,
};

const ownersipAreasReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_OWNERSHIPAREAS:
      return Object.assign({}, state, {
        dataState: states.REQUEST,
        ownershipAreas: [],
      });
    case RESPONSE_OWNERSHIPAREAS:
      return Object.assign({}, state, {
        dataState: states.READY,
        ownershipAreas: action.data.ownershipAreas,
      });
    case REQUEST_OWNERSHIPAREAS_FAILURE:
      return Object.assign({}, state, {
        dataState: states.FAILURE,
        errors: action.errors,
      });

    default:
      return state;
  }
};

export default ownersipAreasReducer;
